import { SharedLocale, type SharedLocalizedString } from "../SharedLocale.js";

export const sharedLocaleShortHandMap = {
	[SharedLocale.cs]: "cz",
	[SharedLocale.en]: "en",
	[SharedLocale.pl]: "pl",
	[SharedLocale.sk]: "sk",
} satisfies SharedLocalizedString;
